module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "book-title"
  }, [_vm._v("1,000 Vegetarian Recipes")]), _vm._v(" "), _c('p', {
    staticClass: "author-byline"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Carol Gelles")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text",
    staticStyle: {
      "text-align": "center",
      "page-break-after": "always"
    }
  }, [_vm._v("Houghton Mifflin Harcourt"), _c('br'), _vm._v("\n\t\t\tBoston ● New York ● 2015")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("Copyright © 1996 by Carol Gelles")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_vm._v("For information about permission to reproduce selections from this book, write to trade.permissions@hmhco.com or to Permissions, Houghton Mifflin Harcourt Publishing Company, 3 Park Avenue, 19th Floor, New York, New York 10016.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_c('a', {
    attrs: {
      "href": "http://www.hmhco.com",
      "target": "_blank"
    }
  }, [_vm._v("www.hmhco.com")])])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("A catalogue record is available from the Library of Congress.")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("eBook ISBN 978-0-544-18917-1")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright-text"
  }, [_c('span', {
    staticClass: "generated-style"
  }, [_vm._v("v2.0915")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ce143fee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ffirs-1.vue
// module id = 60
// module chunks = 0